document.addEventListener('DOMContentLoaded', () => {
  // Menu mobile
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Galerie produit
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.src;
        main.srcset = '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  // Pop-up « autres offres » au clic sur Commander
  document.querySelectorAll('[data-buy-box]').forEach((box) => {
    const dialog = box.querySelector('[data-upsell]');
    const hasDialog = dialog && typeof dialog.showModal === 'function';
    const list = hasDialog && dialog.querySelector('[data-upsell-offers]');
    const addon = box.querySelector('[data-addon]');
    const checks = box.querySelectorAll('[data-addon-check]');
    // Les cases « ebook » de la fiche et du pop-up restent synchronisées
    checks.forEach((c) => c.addEventListener('change', () => checks.forEach((o) => { o.checked = c.checked; })));
    let pending = null;
    window.addEventListener('pageshow', () => box.querySelectorAll('.offer__form').forEach((f) => delete f.dataset.confirmed));
    const go = async (form) => {
      form.dataset.confirmed = '1';
      if (hasDialog && dialog.open) dialog.close();
      if (addon && checks[0].checked && !form.closest('[data-sub]')) {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [addon.dataset.addon]: 1 } })
          });
        } catch (e) {}
      }
      form.requestSubmit ? form.requestSubmit() : form.submit();
    };
    box.querySelectorAll('.offer__form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (form.dataset.confirmed) return;
        event.preventDefault();
        pending = form;
        if (!hasDialog) { go(form); return; }
        list.innerHTML = '';
        // Uniquement des offres supérieures : variantes plus chères, et l'abonnement seulement pour qui prend 1 pot
        const chosen = form.closest('.offer');
        const chosenPrice = chosen.hasAttribute('data-sub') ? Infinity : Number(chosen.dataset.price);
        box.querySelectorAll('.offer').forEach((card) => {
          const other = card.querySelector('.offer__form');
          if (!other || other === form || card.classList.contains('is-soldout')) return;
          const isUpsell = card.hasAttribute('data-sub') ? chosen.hasAttribute('data-first') : Number(card.dataset.price) > chosenPrice;
          if (!isUpsell) return;
          const item = document.createElement('div');
          item.className = 'upsell__offer';
          const img = card.querySelector('.offer__media img');
          if (img) {
            const thumb = img.cloneNode();
            thumb.removeAttribute('sizes');
            thumb.loading = 'eager';
            item.appendChild(thumb);
          }
          const info = document.createElement('div');
          info.className = 'upsell__info';
          const badge = card.querySelector('.offer__badge');
          const name = card.querySelector('.offer__name');
          const note = card.querySelector('.offer__note');
          const price = card.querySelector('.offer__price');
          if (badge) info.insertAdjacentHTML('beforeend', `<span class="upsell__badge">${badge.textContent}</span>`);
          if (name) info.insertAdjacentHTML('beforeend', `<strong>${name.textContent}</strong>`);
          if (note) info.insertAdjacentHTML('beforeend', `<small>${note.textContent.trim()}</small>`);
          if (price) info.insertAdjacentHTML('beforeend', `<span class="upsell__price">${price.innerHTML}</span>`);
          item.appendChild(info);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'upsell__pick';
          button.textContent = 'Choisir';
          button.addEventListener('click', () => go(other));
          item.appendChild(button);
          list.appendChild(item);
        });
        const text = dialog.querySelector('[data-upsell-text]');
        if (text) text.hidden = !list.children.length;
        // Abonnement : pas d'ebook à acheter (le livret est inclus), juste le titre et le bouton paiement
        const isSub = chosen.hasAttribute('data-sub');
        const popupAddon = dialog.querySelector('[data-addon]');
        if (popupAddon) popupAddon.hidden = isSub;
        // Pas d'offre supérieure ni d'ebook à proposer : on passe directement au paiement
        if (!isSub && !list.children.length && !(addon && !checks[0].checked)) { go(form); return; }
        dialog.showModal();
      });
    });
    if (!hasDialog) return;
    dialog.querySelector('[data-upsell-continue]').addEventListener('click', () => pending && go(pending));
    dialog.querySelector('[data-upsell-close]').addEventListener('click', () => dialog.close());
    // Ferme seulement en cliquant à l'extérieur de la fenêtre (pas dans ses marges)
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) dialog.close();
    });
  });
});
